module.exports={"wireguard adapter settings":"Ajustes del adaptador para wireguard",option1:"Opción 1",option2:"opcion 2"};